import { IStates } from '../../manager/lands/model/iMpciPolicy';
import { URLs } from '../../commom/constant';
import { ApiGateway } from '../../components/apiGateway/useApiGateway';
import ApplicationIdValues from '../../components/apiGateway/ApplicationIdValues';

export const getStates = (api: ApiGateway): Promise<IStates[]> => {
    return api.get(URLs.paw_api_version + "/States", ApplicationIdValues.Paw);
};